import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";
import AnimatedSection from "@/components/layout/AnimatedSection";
import { targetAudience, fadeUp, WHATSAPP_QUOTE_URL } from "@/data/site";

const TargetAudience = () => {
  return (
    <AnimatedSection id="para-quem" className="section-padding bg-white">
      <div className="container-custom">
        <motion.div variants={fadeUp} className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#E73336] mb-4 block">
            Soluções sob medida
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#234D89] mb-4">
            Para Quem Atendemos
          </h2>
          <div className="section-divider mx-auto mb-6" />
          <p className="text-[#5C5C5C] max-w-2xl mx-auto">
            Atendemos diversos segmentos do mercado com soluções personalizadas para cada necessidade.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {targetAudience.map((item, index) => (
            <motion.div
              key={item.title}
              variants={fadeUp}
              custom={index}
              whileHover={{ y: -8 }}
              data-testid={`audience-card-${index}`}
              className="group text-center p-7 bg-[#F5F5F5] rounded-3xl hover:bg-[#234D89] transition-all duration-500 cursor-pointer"
            >
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center mx-auto mb-5 shadow-lg group-hover:bg-[#E73336] transition-colors duration-500">
                <item.icon size={32} weight="duotone" className="text-[#234D89] group-hover:text-white transition-colors duration-500" />
              </div>
              <h3 className="text-lg font-bold text-[#234D89] group-hover:text-white mb-2 transition-colors duration-500">
                {item.title}
              </h3>
              <p className="text-[#5C5C5C] group-hover:text-white/70 text-sm leading-relaxed transition-colors duration-500">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div variants={fadeUp} className="text-center mt-12">
          <p className="text-[#5C5C5C] mb-6">
            Não encontrou seu segmento? <strong className="text-[#234D89]">Atendemos todos os tipos de projeto!</strong>
          </p>
          <motion.a
            href={WHATSAPP_QUOTE_URL}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#E73336] text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#BD2A2C] transition-all shadow-lg shadow-[#E73336]/20"
          >
            <WhatsappLogo weight="fill" size={22} />
            Falar com Especialista
          </motion.a>
        </motion.div>
      </div>
    </AnimatedSection>
  );
};

export default TargetAudience;
